import { render, staticRenderFns } from "./InstitutionBulkLoading.vue?vue&type=template&id=73a40241&scoped=true"
import script from "./InstitutionBulkLoading.vue?vue&type=script&lang=js"
export * from "./InstitutionBulkLoading.vue?vue&type=script&lang=js"
import style0 from "./InstitutionBulkLoading.vue?vue&type=style&index=0&id=73a40241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a40241",
  null
  
)

export default component.exports